module.exports = __webpack_public_path__ + "img/service-parts-display-parallax-chevy.57abd5af.png";